export enum DefaultModelField {
  Id = 'id',
  CreatedAt = 'createdAt',
  DeletedAt = 'deletedAt',
  UpdatedAt = 'updatedAt',
}

export interface BaseDBItemModel {
  [DefaultModelField.CreatedAt]?: string;
  [DefaultModelField.DeletedAt]?: string;
  [DefaultModelField.UpdatedAt]?: string;
}

export interface DefaultModel extends BaseDBItemModel {
  [DefaultModelField.Id]: string;
}
